import { Routes } from '@angular/router';
import { WorkflowAdminComponent } from './workflow-admin/workflow-admin.component';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';

export const workflowRoutes: Routes = [
    {
        path: 'workflow/config',
        component: WorkflowAdminComponent,
        canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
        data: { enterpriseModules: ['WORKFLOW_AUTOMATION'], enterpriseFeatureLabel: 'Workflow Automation', permission: app_permissions.workflow.manage }
    }
];
